import { render, staticRenderFns } from "./CoreBright.vue?vue&type=template&id=364ac643&scoped=true&"
import script from "./CoreBright.vue?vue&type=script&lang=js&"
export * from "./CoreBright.vue?vue&type=script&lang=js&"
import style0 from "./CoreBright.vue?vue&type=style&index=0&id=364ac643&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364ac643",
  null
  
)

export default component.exports